import React from "react";
import CustomNavTop from "./CustomNavTop/CustomNavTop";
import CustomNavCarousel from "./CustomNavCarousel/CustomNavCarousel";
import CustomNav from "./CustomNav/CustomNav";

// Custom Styles
import "./header.styles.scss";

function Header() {
  return (
    <header>
      <CustomNavTop />
      <CustomNavCarousel />
      <CustomNav />
    </header>
  );
}

export default Header;
